import { render, staticRenderFns } from "./EditRequest.vue?vue&type=template&id=5505ebb2&scoped=true"
import script from "./EditRequest.vue?vue&type=script&lang=js"
export * from "./EditRequest.vue?vue&type=script&lang=js"
import style0 from "./EditRequest.vue?vue&type=style&index=0&id=5505ebb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505ebb2",
  null
  
)

export default component.exports